import * as React from 'react';
import { FelaComponent, StateProvider } from '@filou/core';
import { TransitionGroup, Transition } from 'react-transition-group';
import Grid from '../grid';
import renderText from '../render-text';
var length = 1000;
var opacity = 'opacity';
var transform = 'transform';
var rule = function (_a) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, _c = _a.state, state = _c === void 0 ? null : _c;
    var _d, _e, _f, _g;
    return ({
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        transition: "all " + length + "ms cubic-bezier(0.165, 0.84, 0.44, 1)",
        zIndex: 0,
        'backface-visibility': 'hidden',
        perspective: 1000,
        textAlign: 'right',
        '& img': {
            transform: 'translateX(-25px)',
            ifSmallDown: {
                transform: 'none'
            }
        },
        ifSmallDown: {
            textAlign: 'center'
        },
        extend: [
            {
                condition: state === 'entering',
                style: (_d = {
                        position: 'absolute'
                    },
                    _d[opacity] = 0,
                    _d[transform] = inverted ? 'translateX(-100px)' : 'translateX(100px)',
                    _d.zIndex = 1,
                    _d)
            },
            {
                condition: state === 'entered',
                style: (_e = {}, _e[opacity] = 1, _e[transform] = 'translateX(0px)', _e)
            },
            {
                condition: state === 'exiting',
                style: (_f = {
                        position: 'absolute'
                    },
                    _f[opacity] = 0,
                    _f[transform] = inverted ? 'translateX(100px)' : 'translateX(-100px)',
                    _f.zIndex = -1,
                    _f)
            },
            {
                condition: state === 'exited',
                style: (_g = {}, _g[opacity] = 0, _g.zIndex = -1, _g)
            }
        ]
    });
};
var style = {
    // textAlign: 'right',
    ifSmallDown: {
        '> div > div > div': {
            flexDirection: 'column-reverse',
            textAlign: 'center'
        }
    }
};
var Tabs = function (_a) {
    var id = _a.id, title = _a.title, subtitle = _a.subtitle, background = _a.background, titleColor = _a.titleColor, _b = _a.keyField, keyField = _b === void 0 ? 'title' : _b, _c = _a.valueField, valueField = _c === void 0 ? '' : _c, _d = _a.items, items = _d === void 0 ? [] : _d;
    return (React.createElement(StateProvider, null, function (setValue, value) {
        if (value === void 0) { value = 0; }
        return (React.createElement(FelaComponent, { style: style, render: function (_a) {
                var className = _a.className;
                return (React.createElement(Grid, { className: className, titleColor: titleColor, id: id, size: 3, background: background, title: title, alignTitle: "center", subtitle: subtitle },
                    React.createElement(Grid.Item, { size: 2 },
                        React.createElement(TransitionGroup, { component: null },
                            React.createElement(Transition, { key: value, timeout: { enter: length / 2, exit: length } }, function (state) { return (React.createElement(FelaComponent, { rule: rule, state: state, render: function (_a) {
                                    var className = _a.className;
                                    return (React.createElement("div", { className: className }, renderText(valueField
                                        ? items[value][valueField]
                                        : items[value])));
                                } })); }))),
                    React.createElement(Grid.Item, null,
                        React.createElement(FelaComponent, { rule: function (_a) {
                                var theme = _a.theme;
                                return ({
                                    listStyleType: 'none',
                                    padding: 0,
                                    // textAlign: 'right',
                                    ifSmallDown: {
                                        textAlign: 'center'
                                    },
                                    '> li': {
                                        cursor: 'pointer',
                                        transition: theme.transition,
                                        onHover: {
                                            color: theme.color
                                        }
                                    },
                                    '> [data-active=true]': {
                                        color: theme.color,
                                        fontWeight: 'bold'
                                        // transform: 'scale(1.1)'
                                    }
                                });
                            }, render: function (_a) {
                                var className = _a.className;
                                return (React.createElement("ul", { className: className }, items.map(function (item, i) { return (React.createElement("li", { key: i, "data-active": value === i, onClick: function () { return setValue(i); } }, item[keyField])); })));
                            } }))));
            } }));
    }));
};
export default Tabs;
//# sourceMappingURL=index.js.map